import { render, staticRenderFns } from "./c_goods.vue?vue&type=template&id=7199c4ee&scoped=true"
import script from "./c_goods.vue?vue&type=script&lang=js"
export * from "./c_goods.vue?vue&type=script&lang=js"
import style0 from "./c_goods.vue?vue&type=style&index=0&id=7199c4ee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7199c4ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7199c4ee')) {
      api.createRecord('7199c4ee', component.options)
    } else {
      api.reload('7199c4ee', component.options)
    }
    module.hot.accept("./c_goods.vue?vue&type=template&id=7199c4ee&scoped=true", function () {
      api.rerender('7199c4ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_goods.vue"
export default component.exports